import React, { useEffect, useState } from 'react'
import { useForm } from '../../hooks/useForm';
import { cargarCalificacionFinal, verificarNotificacion } from '../../utils/Datos';
import Swal from 'sweetalert2'
import { UrlWs } from '../../utils/Global';

export const VerificarNotificacion = ({id_participant}) => {
    const [calificacionFinal, setcalificacionFinal] = useState(null)
    const [documentoError, setdocumentoError] = useState(false)


    const [isFile,setisFile]=useState(false)
    const [valoresForm, handleInputChange, reset, updateValue, updateState] =
    useForm({
        id_qualifications:null,
        notifiedComment:null,
        proofShipmentDocument:null
    });

    const handleFile=(e)=>{
        console.log(e.target.files);
        console.log(`Selected file - ${e.target.files[0].name}`);  
        let name=e.target.files[0].name;
        let type=e.target.files[0].type;
        setisFile(true);

        /**ARCHIVO A BASE 64 */
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            let fileBase64 = reader.result.replace("data:application/pdf;base64,", "");
            updateValue("proofShipmentDocument",{
                id_qualifications:calificacionFinal.datos.id_qualifications,
                name:name,
                contentType:type,
                contentByte:fileBase64
            })
        };
        reader.onerror = function (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error...',
                text: error
            });
            setisFile(false);
        };
    }

    const handleComment=(e)=>{
        //alert(e.target.value);
        updateValue("notifiedComment",e.target.value);
    }

    const handleVerificar=()=>{
       // alert(id_participant);
       console.log(valoresForm);
        //if (!isFile) {
            //setdocumentoError(true);
        //}else{
            //setdocumentoError(false);
            if(valoresForm.notifiedComment===null){
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: 'Debe seleccionar una alternativa'
                });
            }else{
                verificarNotificacion(valoresForm).then((respuesta)=>{
                    if (respuesta===null) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error...',
                            text: 'La calificación ya fue enviada'
                        });
                    }else{
                        Swal.fire({
                            icon: 'success',
                            title: 'Correcto',
                            text: 'La verificación fue enviada'
                        }).then((okay) => {
                            if (okay) {
                              window.location.href = "/procesoConformidad";
                            }
                        });
                    }
                });
            }
        //}

        
    }

    useEffect(() => {
        cargarCalificacionFinal(id_participant).then((calificacion)=>{
            setcalificacionFinal(calificacion);
            console.log(calificacion);
            if (calificacion.status) {
                updateValue("id_qualifications",calificacion.datos.id_qualifications);
                //updateValue("proofShipmentDocument",calificacion.datos.id_qualifications);
            }
        })
    }, [id_participant])
    

    return  <div className='row mt-5 pt-3'>
            <div className="col-md-6">
                <div className="fw-bold">
                    
                    <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="notificacionTipo"
                            value="Notificación por Carta"
                            onChange={handleComment}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="apelar"
                        >
                            Notificación por carta
                        </label>
                    </div>
                    <div className="form-check form-check-custom form-check-danger form-check-solid">
                        <input
                            className="form-check-input"
                            type="radio"
                       
                            name="notificacionTipo"
                           
                            value="Notificación Presencial"
                            onChange={handleComment}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="no-apelar"
                        >
                            Notificación presencial
                        </label>
                    </div>
                    {}
                </div>
            </div>

            <div className='col-md-6'>
                <label>Subir documento de notificación</label>
                <input type="file" 
                onChange={handleFile}
                className={documentoError ? 'form-control is-invalid':'form-control'} name="documento"></input>
                <br/>
                <div className='text-right'>
                    <button 
                        onClick={handleVerificar}
                        className="btn btn-primary right" style={{marginRight:0}}> Verificar</button>
                </div>
            </div>
        </div>
    
}
